import { render, staticRenderFns } from "./lead-info-box.vue?vue&type=template&id=0e1abd94&"
import script from "./lead-info-box.vue?vue&type=script&lang=js&"
export * from "./lead-info-box.vue?vue&type=script&lang=js&"
import style0 from "./lead-info-box.vue?vue&type=style&index=0&id=0e1abd94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports